<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Lato');

  * {
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }

  .el-alert {
    margin-bottom: 16px;
  }

  .mb-16, .mb-6 {
    margin-bottom: 32px;
  }

  h3 {
    text-align: center;
    white-space: pre-wrap;
  }
  .orc-slope {
    position: relative;
  }
  .orc-slope:after {
    content: "";
    background: #00a5ff;
    height: 100px;
    transform: skewY(-2deg);
    position: absolute;
    left: 0;
    right: 0;
    bottom: -25px;
    z-index: -1;
  }

  .orc-slope:before {
    content: "";
    background: #00a5ff;
    height: 100px;
    transform: skewY(-2deg);
    position: absolute;
    left: 0;
    right: 0;
    top: -25px;
    z-index: -1;
  }

  .ui-pill {
    padding: 4px 4px;
    min-width: 120px;
    text-align: center;
    border-radius: 4px;
    opacity: 0.6;
  }

  .orc-opc {
    opacity: 0.6;
  }

  .ui-pill:hover {
    opacity: 1;
  }

  .ui-pill.border {
    opacity: 1;
    padding: 6px 16px;
    border: 0;
    color: white;
    background-color: rgba(255, 255, 255, 0.3);
  }

  .ui-pill + .ui-pill {
    margin-left: 10px;
  }

  .ui-pill.selected {
    opacity: 1;
  }

  .ui-pill.border:hover {
    background-color: white;
    color: #00a5ff;
  }

  span.orc-label {
    padding: 0.2em;
    display: block;
    margin-bottom: 5px;
    font-size: 12px;
    text-align: center;
    color: rgba(0, 0, 0, 0.4);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
  }

  .logo {
    font-family: 'Lato', sans-serif;
    text-transform: uppercase;
    color: white;
    font-size: 22px;
    letter-spacing: 0.1em;
  }

  .orc-wave {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    top: 0;
    background: url('./assets/orca.svg') no-repeat;
    background-size: 115%;
    background-position: bottom;
    z-index: 0;
    margin-bottom: -10px;
  }

  .el-date-editor.w-full {
    width: 100% !important;
  }

  *:focus {
    outline: none;
  }

  .orc-vert-limit-header {
    max-width: 960px;
    margin: 0 auto;
    padding: 0 30px;
  }

  .orc-vert-limit-content {
    max-width: 640px;
    padding: 0 30px;
    margin: 0 auto;
  }

  .orc-wave-blue {
    background: url('assets/orca-blue.svg') no-repeat white;
    background-size: 300%;
    background-position: -220px bottom;
  }

  a.social-badge {
    background-color: rgba(255, 255, 255, 0.3);
    color: white;
    border-radius: 4px;
    height: 40px;
    width: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    padding:10px;
  }

  a.social-badge img {
    height: 100%;
    width: 100%;
  }

  @media only screen and (max-width: 600px) {
    .orc-wave {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue